import { render, staticRenderFns } from "./Standardfolie.vue?vue&type=template&id=0e12607c&scoped=true&"
import script from "./Standardfolie.vue?vue&type=script&lang=js&"
export * from "./Standardfolie.vue?vue&type=script&lang=js&"
import style0 from "./Standardfolie.vue?vue&type=style&index=0&id=0e12607c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e12607c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer})
